require('./vendor/modernizr-custom');
require('./vendor/object-fit-videos');
require('./vendor/jquery.accordion');

require('./navigation');
require('./skip-link-focus-fix');
require('./scripts-slick');
require('./scripts-magnific');
require('./scripts-uniform');
// require('./scripts-lightordark');
require('./scripts');
